import { Box } from '@material-ui/core';
import { useFormik } from 'formik';
import RecieveNewsField from '../../../../common/forms/fields/components/recieveNewsField';
import ConfirmationField from '../../../../common/forms/fields/components/confirmationField';
import { useEffect, useRef } from 'react';
import { newsFieldLocation } from '../../../../constants/checkout.constant';

const ReceiveLatestNewsForm = ({
  handleSave,
  codeTableData,
  language,
  formData,
  formName,
}) => {
  const isFirstRun = useRef(true);

  const formik = useFormik({
    initialValues: { ...formData },
    enableReinitialize: true,
  });

  useEffect(() => {
    if (typeof formik.values.receivedLatestNews !== 'boolean') {
      return;
    }
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    handleSave({ name: formName, formik });
  }, [formik.values.receivedLatestNews]);

  return (
    <Box className="panel-body">
      <form onSubmit={formik.handleSubmit}>
        <Box>
          <Box className="field field--title">
            <RecieveNewsField
              name="receivedLatestNews"
              form={formik}
              key={1}
              externalData={codeTableData}
              language={language}
              type={newsFieldLocation.MyAccount}
            />
          </Box>
          <Box pt={5} pb={5} mb={5}>
            <ConfirmationField label></ConfirmationField>
          </Box>
        </Box>
      </form>
    </Box>
  );
};

export default ReceiveLatestNewsForm;
